import {BACKEND_API} from '../middleware/backend'

export const EXITS_REQUEST = 'EXITS_REQUEST';
export const EXITS_SUCCESS = 'EXITS_SUCCESS';
export const EXITS_FAILURE = 'EXITS_FAILURE';
export const EXITS_COUNT_REQUEST = 'EXITS_COUNT_REQUEST';
export const EXITS_COUNT_SUCCESS = 'EXITS_COUNT_SUCCESS';
export const EXITS_COUNT_FAILURE = 'EXITS_COUNT_FAILURE';
export const EXIT_REQUEST = 'EXIT_REQUEST';
export const EXIT_SUCCESS = 'EXIT_SUCCESS';
export const EXIT_FAILURE = 'EXIT_FAILURE';
export const EXIT_SAVE_REQUEST = 'EXIT_SAVE_REQUEST';
export const EXIT_SAVE_SUCCESS = 'EXIT_SAVE_SUCCESS';
export const EXIT_SAVE_FAILURE = 'EXIT_SAVE_FAILURE';
export const EXIT_INFO_REQUEST = 'EXIT_INFO_REQUEST';
export const EXIT_INFO_SUCCESS = 'EXIT_INFO_SUCCESS';
export const EXIT_INFO_FAILURE = 'EXIT_INFO_FAILURE';

export const loadExits = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [EXITS_REQUEST, EXITS_SUCCESS, EXITS_FAILURE],
			endpoint: "exit/list",
			filter: filter
		}
	})
};

export const countExits = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [EXITS_COUNT_REQUEST, EXITS_COUNT_SUCCESS, EXITS_COUNT_FAILURE],
			endpoint: "exit/count",
			filter: filter
		}
	})
};

export const loadExit = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [EXIT_REQUEST, EXIT_SUCCESS, EXIT_FAILURE],
			endpoint: `exit/${id}`,
		}
	})
};

export const saveExit = (exit) => (dispatch, getState) => {
	return dispatch({
		id: exit.exitId,
		exit: exit,
		[BACKEND_API]: {
			types: [EXIT_SAVE_REQUEST, EXIT_SAVE_SUCCESS, EXIT_SAVE_FAILURE],
			endpoint: 'exit',
			body: exit,
			silent: true
		}
	})
};

export const loadExitInfo = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [EXIT_INFO_REQUEST, EXIT_INFO_SUCCESS, EXIT_INFO_FAILURE],
			endpoint: `exit/info/${id}`,
		}
	})
};



// WEBPACK FOOTER //
// ./src/actions/exits.js